//todo 声学分析grid
export const getNoiseAnalysisLineGrid = function (style) {
  let grid = [
    {
      left: style.grid[0].left,
      right: style.grid[0].right,
      top: 90, //离方块距离
      bottom: 35,
    },
    {
      height: 32, //方块
      left: style.grid[1].left,
      right: style.grid[1].right,
      top: 35,
      bottom: 30,
    },
  ];
  return grid;
};

export const baseSmallPadding = 10;
export const baseSmallBottomPadding = 0;
export const baseDefaultPadding = 30;  // 默认的左右边距
// export const baseDefaultVerticalPadding = 30;  // 默认的上下边距
export const baseDefaultTopPadding = 22;  // 默认的上下边距
export const baseDefaultBottomPadding = 15;

export const horizontalLeftPadding = 10;
export const horizontalRightPadding = 50;
export const horizontalBottomPadding = 15;

export const horizontalSmallLeftPadding = 5;
export const horizontalSmallRightPadding = 50;
export const horizontalSmallBottomPadding = 15
